/**
 * The list only ever shows one pipeline, so a select-all scope must carry it — the backend would
 * otherwise resolve the filters across every pipeline.
 *
 * @param {Object|null} scope - From useScopedSelection's toScope / toActionScope
 * @param {string} pipelineId
 * @returns {Object|null}
 */
export const withPipelineScope = (scope, pipelineId) =>
	scope?.selectAll ? { ...scope, filters: { pipelineId, ...scope.filters } } : scope;
